export enum LabTestingParameterType {
  WidthInches = 0,
  WeightGrams = 1,
  ShrinkageLength = 2,
  ShrinkageWidth = 3,
  Torque = 4,
  CPI = 5,
  WPI = 6,
  Bursting = 7,
  PillingWash = 8,
  PH = 9,
  WaterFastness = 10,
  PerspirationFastness = 11,
  CrockingDry = 12,
  CrockingWet = 13,
  PrimaryIllumination = 14,
}

export const LabTestingParameterTypeLabels: Record<LabTestingParameterType, { en: string; es: string }> = {
  [LabTestingParameterType.WidthInches]: { en: 'Width (Inches)', es: 'Ancho (Pulg.)' },
  [LabTestingParameterType.WeightGrams]: { en: 'Weight (Grams)', es: 'Peso (GRMS)' },
  [LabTestingParameterType.ShrinkageLength]: { en: 'Shrinkage Length', es: 'Encogimiento Largo' },
  [LabTestingParameterType.ShrinkageWidth]: { en: 'Shrinkage Width', es: 'Encogimiento Ancho' },
  [LabTestingParameterType.Torque]: { en: 'Torque', es: 'Torque' },
  [LabTestingParameterType.CPI]: { en: 'CPI ±1', es: 'CPI ±1' },
  [LabTestingParameterType.WPI]: { en: 'WPI ±1', es: 'WPI ±1' },
  [LabTestingParameterType.Bursting]: { en: 'Bursting', es: 'Bursting' },
  [LabTestingParameterType.PillingWash]: { en: 'Pilling Wash', es: 'Pilling al Lavado' },
  [LabTestingParameterType.PH]: { en: 'PH', es: 'PH' },
  [LabTestingParameterType.WaterFastness]: { en: 'Water Fastness', es: 'Solidez al Agua' },
  [LabTestingParameterType.PerspirationFastness]: { en: 'Perspiration Fastness', es: 'Solidez al Sudor' },
  [LabTestingParameterType.CrockingDry]: { en: 'Crocking Dry', es: 'Crocking Seco' },
  [LabTestingParameterType.CrockingWet]: { en: 'Crocking Wet', es: 'Crocking Húmedo' },
  [LabTestingParameterType.PrimaryIllumination]: { en: 'Primary Illumination', es: 'Iluminación Primaria' },
};
